angular.module('LegendSettings').factory('LegendService', function ($http, $httpParamSerializerJQLike) {
  'use strict';
  var settings = jQuery('#settings');
  var rootUri = settings.data('root-uri') ? settings.data('root-uri') : '';
  var commune = settings.data('commune-id');
  var indicatorData = settings.data('indicator-data') ? settings.data('indicator-data') : 0;
  var ajaxTargetPid = 0;

  return {
    persistLegend: function (legend, type) {
      return $http
        .post(rootUri, $httpParamSerializerJQLike({
          'arguments[data]': {
            legend: legend,
            type: type,
            indicatorData: indicatorData
          }
        }), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'persistLegend'
          }
        }).then(function (response) {
          return response.data;
        });
    },
    removeLegend: function (legend, type) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'deleteLegend',
            'arguments[legendUid]': legend,
            'arguments[indicatorDataUid]': indicatorData,
            'arguments[type]': type
          }
        });
    },
    getLegend: function (id) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getLegend',
            'arguments[legendUid]': id
          }
        }).then(function (response) {
          if (response.data.uid) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    getDistrictsFromLayer: function (layerUid) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getDistrictsFromLayer',
            'arguments[layerUid]': layerUid
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    getRelated: function (ids) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'getRelatedLegends',
            'arguments[legendUids]': JSON.stringify(ids)
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },
    copyLegend: function (uid, type) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'ItaoKeck',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'copyLegend',
            'arguments[legendUid]': uid,
            'arguments[indicatorDataUid]': indicatorData,
            'arguments[type]': type
          }
        }).then(function (response) {
          if (response.data) {
            return response.data;
          } else {
            return false;
          }
        });
    },

    /**
     * Fetches all indicator-sets data and transforms it to IndicatorSets
     * @returns {Promise} When resolved, an array of IndicatorSets
     */
    getColorSets: function () {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listColorSets',
            'arguments[commune]': commune
          }
        }).then(function (response) {
          return response.data.map(mapColorSets);
        });
    },

    /**
     * Fetches all indicator-sets data and transforms it to IndicatorSets
     * @param {int} indicatorTypeUid
     * @returns {Promise} When resolved, an array of IndicatorSets
     */
    getIndicatorTypeLists: function (indicatorTypeUid) {
      return $http
        .get(rootUri, {
          params: {
            'id': ajaxTargetPid,
            'extensionName': 'Itaohyperion',
            'pluginName': 'Pi102',
            'controllerName': 'AtlasJson',
            'actionName': 'listIndicatorTypeLists',
            'arguments[indicatorTypeUid]': indicatorTypeUid
          }
        }).then(function (response) {
          return response.data;
        });
    }
  };

  /**
   * creates the ColorSet objects from raw ColorSet data
   * @param {Object} rawColorSet
   * @returns {Array}
   */
  function mapColorSets(rawColorSet) {
    return {
      uid: rawColorSet.uid,
      name: rawColorSet.name,
      colors: rawColorSet.colors
    }
  }
});
